export default __webpack_public_path__ + "static/media/completezza_cv.c696db78.less";